var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"canvasArea",staticClass:"tegaki-canvas"},[_c('canvas-drawing-base',{ref:"canvas",staticClass:"tegaki-canvas__canvas",on:{"dragStart":_vm.dragStart,"dragEnd":_vm.dragEnd,"dragging":_vm.dragging}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }